module.exports = __webpack_public_path__ + "static/media/Bell List.5b368e48.png";